
import { useQuery } from "@tanstack/react-query";
import { TaskType } from "@/types/task";

export const useTaskTypes = () => {
  const { data: taskTypes = [], isLoading } = useQuery({
    queryKey: ["task-types"],
    queryFn: async (): Promise<TaskType[]> => {
      // For now, return default types. Later this can be from database
      const now = new Date().toISOString();
      return [
        { id: 'client', name: 'مهمة عميل', description: 'مهام متعلقة بالعملاء', color: '#3b82f6', created_at: now },
        { id: 'supplier', name: 'مهمة مورد', description: 'مهام متعلقة بالموردين', color: '#10b981', created_at: now },
        { id: 'administrative', name: 'مهمة إدارية', description: 'مهام إدارية داخلية', color: '#f59e0b', created_at: now },
        { id: 'operational', name: 'مهمة تشغيلية', description: 'مهام تشغيلية يومية', color: '#8b5cf6', created_at: now },
        { id: 'general', name: 'مهمة عامة', description: 'مهام عامة متنوعة', color: '#6b7280', created_at: now }
      ];
    },
  });

  return { taskTypes, isLoading };
};
